export interface CountryCode {
  code: string;
  name: string;
  dialCode: string;
  flag: string;
}

export const COUNTRY_CODES: CountryCode[] = [
  { code: "IN", name: "India", dialCode: "+91", flag: "🇮🇳" },
  { code: "US", name: "USA", dialCode: "+1", flag: "🇺🇸" },
  { code: "GB", name: "UK", dialCode: "+44", flag: "🇬🇧" },
  { code: "AE", name: "UAE", dialCode: "+971", flag: "🇦🇪" },
  { code: "SA", name: "Saudi Arabia", dialCode: "+966", flag: "🇸🇦" },
  { code: "CA", name: "Canada", dialCode: "+1", flag: "🇨🇦" },
  { code: "AU", name: "Australia", dialCode: "+61", flag: "🇦🇺" },
  { code: "NZ", name: "New Zealand", dialCode: "+64", flag: "🇳🇿" },
  { code: "SG", name: "Singapore", dialCode: "+65", flag: "🇸🇬" },
  { code: "MY", name: "Malaysia", dialCode: "+60", flag: "🇲🇾" },
  { code: "DE", name: "Germany", dialCode: "+49", flag: "🇩🇪" },
  { code: "FR", name: "France", dialCode: "+33", flag: "🇫🇷" },
  { code: "OM", name: "Oman", dialCode: "+968", flag: "🇴🇲" },
  { code: "QA", name: "Qatar", dialCode: "+974", flag: "🇶🇦" },
  { code: "KW", name: "Kuwait", dialCode: "+965", flag: "🇰🇼" },
  { code: "BH", name: "Bahrain", dialCode: "+973", flag: "🇧🇭" },
];

export const DEFAULT_COUNTRY_CODE = COUNTRY_CODES[0]; // India

/**
 * Find country by dial code
 */
export function findCountryByDialCode(dialCode: string): CountryCode | undefined {
  return COUNTRY_CODES.find(c => c.dialCode === dialCode);
}

/**
 * Parse a phone number to extract country code and number
 * Handles formats like: +91 9876543210, +919876543210, 9876543210
 */
export function parsePhoneWithCode(phone: string | null | undefined): { countryCode: CountryCode; number: string } {
  if (!phone) {
    return { countryCode: DEFAULT_COUNTRY_CODE, number: "" };
  }

  // Clean the phone number
  const cleaned = phone.trim();
  
  // Check if starts with +
  if (cleaned.startsWith("+")) {
    // Try to match known country codes (longest first)
    const sortedCodes = [...COUNTRY_CODES].sort((a, b) => b.dialCode.length - a.dialCode.length);
    
    for (const country of sortedCodes) {
      const dialCodeWithoutPlus = country.dialCode.replace("+", "");
      const phoneWithoutPlus = cleaned.replace("+", "").replace(/\s/g, "");
      
      if (phoneWithoutPlus.startsWith(dialCodeWithoutPlus)) {
        const number = phoneWithoutPlus.substring(dialCodeWithoutPlus.length);
        return { countryCode: country, number };
      }
    }
  }
  
  // If no country code found, assume it's just the number (default to India)
  const numberOnly = cleaned.replace(/[^\d]/g, "");
  return { countryCode: DEFAULT_COUNTRY_CODE, number: numberOnly };
}

/**
 * Format phone number with country code
 */
export function formatPhoneWithCode(dialCode: string, number: string): string {
  const cleanNumber = number.replace(/[^\d]/g, "");
  if (!cleanNumber) return "";
  return `${dialCode} ${cleanNumber}`;
}
